import React from 'react';
import { Link } from 'react-router-dom';

interface ServiceHeroProps {
  icon: string;
  category: string;
  title: string;
  subtitle: string;
  description: string;
  highlights: string[];
  ctaButtons?: {
    primary?: {
      text: string;
      link: string;
    };
    secondary?: {
      text: string;
      link: string;
    };
  };
}

const ServiceHeroSection: React.FC<ServiceHeroProps> = ({
  icon,
  category,
  title,
  subtitle,
  description,
  highlights,
  ctaButtons
}) => {
  return (
    <div className="betaque-service-hero">
        <div className="betaque-service-hero-content">
          <div className="betaque-service-hero-left">
            <div className="betaque-service-meta">
              <span className="betaque-service-icon-large">{icon}</span>
              <span className="betaque-service-category-large">{category}</span>
            </div>
            
            <h1 className="betaque-service-title">{title}</h1>
            <h2 className="betaque-service-subtitle">{subtitle}</h2>
            <p className="betaque-service-description">{description}</p>
            
            <div className="betaque-service-highlights">
              {highlights.map((highlight: string, index: number) => (
                <div key={index} className="betaque-highlight-item">
                  <span className="betaque-highlight-icon">✓</span>
                  <span>{highlight}</span>
                </div>
              ))}
            </div>

            <div className="betaque-service-cta-buttons">
              <Link to="/contact" className="betaque-primary-cta-btn">
                Get Started Today
              </Link>
              <Link to="/contact" className="betaque-secondary-cta-btn">
                Schedule Consultation
              </Link>
            </div>
          </div>
        </div>
      </div>
  );
};

export default ServiceHeroSection;